export default "__VITE_ASSET__CYP2Db7K__"